interface PageHeaderProps {
  title: string;
  description: string;
  actions?: React.ReactNode;
  as?: "h1" | "h2";
}

export function PageHeader({ title, description, actions, as = "h1" }: PageHeaderProps) {
  const Tag = as;
  return (
    <div className="flex items-start justify-between">
      <div>
        <Tag className="text-[22px] font-bold text-brand-950 tracking-tight leading-tight">
          {title}
        </Tag>
        <p className="text-sm text-slate-500 mt-1">{description}</p>
      </div>
      {actions && <div className="flex items-center gap-3">{actions}</div>}
    </div>
  );
}
